export default {
  types: {
    all: 'Todos',
    visited: 'Visitados',
    favorites: 'Favoritos'
  }
}
